<template>

    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
    ><div class="flex items-center">{{ params.value }}</div></router-link>

</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      return `/admin/users/support/view/${this.params.data ? this.params.data.id : 0}`
    }
  }
}
</script>
